// Etiquetas y formateo compartidos por la calculadora de ahorro.

export const FUEL_LABELS = {
    GASOLINE: "Bencina",
    DIESEL: "Diésel",
    ELECTRIC: "Electricidad",
};

export const isElectric = (fuelType) => fuelType === "ELECTRIC";

export const efficiencyUnit = (fuelType) =>
    isElectric(fuelType) ? "km / kWh" : "km / l";

export const priceUnit = (fuelType) => (isElectric(fuelType) ? "$ / kWh" : "$ / l");

export const priceUnitShort = (fuelType) => (isElectric(fuelType) ? "kWh" : "l");
export const priceUnitLong = (fuelType) => (isElectric(fuelType) ? "kWh" : "litro");


const toNumber = (value) => {
    const n = typeof value === "number" ? value : parseFloat(value);
    return Number.isFinite(n) ? n : 0;
};

// $1.417.552 — miles con punto, sin decimales (formato CLP).
export const formatCLP = (value, { withSign = false } = {}) => {
    const n = Math.round(toNumber(value));
    const abs = Math.abs(n).toLocaleString("es-CL");
    const money = `$${abs}`;
    if (!withSign) return n < 0 ? `−${money}` : money;
    return n < 0 ? `−${money}` : `+${money}`;
};

// Rendimiento y precios pueden venir con coma decimal en la UI (es-CL).
export const formatDecimal = (value, decimals = 1) => {
    const n = toNumber(value);
    return n.toLocaleString("es-CL", {
        minimumFractionDigits: 0,
        maximumFractionDigits: decimals,
    });
};

// Un ahorro de exactamente 0 tampoco es "ahorro": va por la variante neutra.
export const savingsIsPositive = (value) => toNumber(value) > 0;

// Monto sin signo, para la variante neutra (el texto ya explica la dirección).
export const formatCLPAbs = (value) => formatCLP(Math.abs(toNumber(value)));

